import React, { useEffect, useState, useContext } from "react";
import { Box, CircularProgress, Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { useGetSwarmsPureQuery } from "../../services/swarmsApi";
import PendingBuyRequests from './pendingBuyRequests';
import { useLazyGetPlatformsForUserQuery } from "../../services/platformsApi";
import AppContext from '../../context/AppProvider';
import { useGetUserBuysQuery } from "../../services/eventApi";
import { useBlackListQuery } from "../../services/blackListApi";
import SwarmSelection from "./SwarmSelection";
import { useGetBuyingEmailWithPlatformsQuery } from "../../services/buyingEmailApi";
import { UserCountPages } from "../../constants/enums";
import { sendSignalRSafe } from "../../utils/signalRSender";
import { selectCurrentUser } from "../../features/auth/authSlice";
import { selectEvents, selectFilteredSwarms, selectRunningSwarms, setEvents, setSwarms, setUserBuys, setBlackListedVenues } from "./store";
import { useDispatch } from "react-redux";
import SignalREncorehiveContext from "@/context/signalREncorehive";
import { useSwarmsForBeeSignalR } from "./hooks/useSwarmsForBeeSignalR.ts";

const LoadingModal = () => {
  return (
    <Box sx={{ display: 'flex', height: '100vh', width: '100%', alignItems: 'center', justifyContent: "center" }}>
      <CircularProgress size={48} sx={{ color: "primary", alignSelf: 'center' }} />
    </Box>
  )
};

export default function Swarms() {
  const { signalRUserConnection } = useContext(AppContext);
  const { signalREncorehive } = useContext(SignalREncorehiveContext);
  const user= useSelector(selectCurrentUser); 
  const dispatch = useDispatch();

  const [getPlatformForUser] = useLazyGetPlatformsForUserQuery();
  const {data:UserBuys} = useGetUserBuysQuery(undefined, { refetchOnMountOrArgChange: true })
  const {data:BLVenues, isLoading, isError} = useBlackListQuery(`?userId=${user.id}&elementType=Venue`)

  const {data: swarmsApiRes, isLoading:loadingSwarms} = useGetSwarmsPureQuery("?Running=true", { refetchOnMountOrArgChange: true})

  useGetBuyingEmailWithPlatformsQuery({AssignedUserID: user.id}) // this query automatically saves the result in the redux store

  // Using the complex selector to get filtered swarms (now from the store)
  const filteredSwarms = useSelector(selectFilteredSwarms);
  
  // Using the selector for active swarms
  const runningSwarms = useSelector(selectRunningSwarms);

  useSwarmsForBeeSignalR(signalREncorehive);

  useEffect(() => {
    if (swarmsApiRes && !loadingSwarms) {
      dispatch(setSwarms(swarmsApiRes.swarms));
      dispatch(setEvents(swarmsApiRes.events));
    }
  }, [swarmsApiRes, loadingSwarms]);

  useEffect(() => {
    if (UserBuys) {
      dispatch(setUserBuys(UserBuys));
    }
  }, [UserBuys, dispatch]);

  useEffect(() => {
    if (BLVenues && !isLoading) {
      dispatch(setBlackListedVenues(BLVenues))
    }
  }, [BLVenues, isLoading]);

  useEffect(() => {
    if (user && user.id) getPlatformForUser(user.id);
  }, [user])

  useEffect(() => {
    if (!user || Object.keys(user).length === 0)
      return;

    sendSignalRSafe(signalRUserConnection, async (connection) => {
      console.log("DEBUG: SetCurrentUser , " , user)
      await connection.send('SetCurrentUser', { Page: UserCountPages.SwarmBuyRequest, UserId: user.id }, user)
    });

    return () => {
      sendSignalRSafe(signalRUserConnection, async (connection) => {
        await connection.send('RemoveCurrentUser', { Page: UserCountPages.SwarmBuyRequest, UserId: user.id})
      });
    };
  }, [user, signalRUserConnection])

  if(loadingSwarms){
    return <LoadingModal />;
  }
  
  return (
    <Box sx={{ width: "100%", display: "flex", justifyContent: "center", padding: "0 4em", marginTop: "8em" }}>
      <Grid container spacing={0} direction="column" alignItems="center" justifyContent="center" >
        <SwarmSelection
          swarms={filteredSwarms}
        />
        <PendingBuyRequests
          show={runningSwarms.length > 0}
        />
      </Grid>
    </Box> 
      
);
}